import React, { Component } from "react";
import { Link } from "react-router-dom";
import Proptypes from "prop-types";
import MyButton from "../../util/MyButton";
// ICONS
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";
// redux
import { connect } from "react-redux";
import { likeScream, unlikeScream } from "../../redux/actions/dataActions";

export class LikeButton extends Component {
  likedScream = () => {
    if (
      this.props.user.likes &&
      this.props.user.likes.find(like => like.screamId === this.props.screamId)
    ) {
      return true;
    } else {
      return false;
    }
  };

  likeScream = () => {
    this.props.likeScream(this.props.screamId);
  };

  unlikeScream = () => {
    this.props.unlikeScream(this.props.screamId);
  };
  render() {
    const { authenticated } = this.props.user;
    const likeButton = !authenticated ? (
      <Link to="/login">
        <MyButton tip="Like">
          <FavoriteBorder color="primary" />
        </MyButton>
      </Link>
    ) : // logged in
    this.likedScream() ? (
      <MyButton tip="Undo Like" onClick={this.unlikeScream}>
        <FavoriteIcon color="primary" />
      </MyButton>
    ) : (
      // NOT logged in
      <MyButton tip="Like" onClick={this.likeScream}>
        <FavoriteBorder color="primary" />
      </MyButton>
    );
    return likeButton;
  }
}

LikeButton.propType = {
  user: Proptypes.object.isRequired,
  screamId: Proptypes.string.isRequired,
  likeScream: Proptypes.func.isRequired,
  unlikeScream: Proptypes.func.isRequired
};

const mapStateToAction = state => ({
  user: state.user
});

const mapActionToProps = {
  likeScream,
  unlikeScream
};
export default connect(mapStateToAction, mapActionToProps)(LikeButton);
